import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { HomeNavbar } from '../../common/home-navbar';
import { Footer } from '../../common/footer';
import { Spinner } from '../../common/spinner';
import { CompareStore } from '../../stores/CompareStore';
import { MainBody } from './main-body';
import styles from './Compare.css';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { SEO } from '../../common/seo';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

class Compare extends React.Component {
  componentDidMount() {
    this._updateProducts();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this._updateProducts();
    }
  }

  componentWillUnmount() {
    CompareStore.clearComparison();
  }

  _updateProducts() {
    const params = ParamsHelper.parseQueryParams(this.props.location.search);
    let productIds = null;
    try {
      productIds = JSON.parse(params.q);
    } catch (error) {
      productIds = [];
    }
    CompareStore.compare(productIds);
  }

  render() {
    const dataLoaded = CompareStore.comparison !== null;
    return (
      <div className={styles.container}>
        <SEO
          title="Comparar productos en Carlos Gutiérrez S.A."
          description="Compara fácilmente productos y servicios en Carlos Gutiérrez S.A. para tomar decisiones de compra informadas. Nuestra herramienta de comparación te permite evaluar características, precios, valoraciones y más, para que encuentres la opción que mejor se ajuste a tus necesidades. Filtra según tus preferencias y descubre las mejores ofertas disponibles. Haz que tu experiencia de compra sea más sencilla y eficiente con nuestra comparativa detallada y actualizada. Encuentra lo que buscas y haz una elección inteligente."
          type="website"
        />
        <HomeNavbar />
        {
          dataLoaded &&
          !CompareStore.compareError &&
          <MainBody
            comparisonData={CompareStore.comparison}
            products={CompareStore.products}
          />
        }
        {
          !dataLoaded &&
          !CompareStore.compareError &&
          <Spinner className={styles.spinner} />
        }
        {
          !dataLoaded &&
          CompareStore.compareError &&
          <div className={styles.errorContainer}>
            <p className={styles.compareError}>
              Ha ocurrido un error al momento de comparar los productos.
            </p>
            <p className={styles.compareError}>
              Por favor intente nuevamente.
            </p>
          </div>
        }
        <Footer />
      </div>
    );
  }
}

const ObservedCompare = observer(Compare);
Compare.propTypes = IPropTypes;

export { ObservedCompare as Compare };



// WEBPACK FOOTER //
// ./src/pages/compare/Compare.jsx